import React, { useState, useEffect } from "react";
import { useAuth } from "../../../usercontext";
import { useParams } from "react-router-dom";
import GlobalStudentTask from "../../pages/common/globalstudenttask";

import StudentInfoBox from "../studentinfo/studentinfobox";
import StudentTopMenu from "../studentinfo/studenttopmenu";

export default function StudentTask() {
  const { profile } = useAuth();
  let { slug } = useParams();
  console.log("slug",slug);
  const isStudent = profile?.role === "Student";
  return (
    <>
      <StudentInfoBox slug={slug} />
      <StudentTopMenu slug={slug} activeMenu={"Task"} />
      <GlobalStudentTask studentId={slug} type={226} isStudent={true} />
    </>
  );
}